/**
 * @generated SignedSource<<75304e5321bd62b87e3fb02c01528eb3>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AIAssetLibrarySortBy = "CREATED_DATE" | "NAME";
export type SortDirection = "ASC" | "DESC";
export type assetLibraryQueriesAIAssetLibraryCategoriesQuery$variables = {
  searchName?: string | null;
  sortBy?: AIAssetLibrarySortBy | null;
  sortDirection?: SortDirection | null;
};
export type assetLibraryQueriesAIAssetLibraryCategoriesQuery$data = {
  readonly aiAssetLibraryCategories: {
    readonly nodes: ReadonlyArray<{
      readonly createdDate: string;
      readonly id: string;
      readonly modifiedDate: string;
      readonly name: string;
      readonly sortOrder: number;
    }> | null;
  } | null;
};
export type assetLibraryQueriesAIAssetLibraryCategoriesQuery = {
  response: assetLibraryQueriesAIAssetLibraryCategoriesQuery$data;
  variables: assetLibraryQueriesAIAssetLibraryCategoriesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "searchName"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sortBy"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sortDirection"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 50
      },
      {
        "kind": "Variable",
        "name": "searchName",
        "variableName": "searchName"
      },
      {
        "kind": "Variable",
        "name": "sortBy",
        "variableName": "sortBy"
      },
      {
        "kind": "Variable",
        "name": "sortDirection",
        "variableName": "sortDirection"
      }
    ],
    "concreteType": "AiAssetLibraryCategoriesConnection",
    "kind": "LinkedField",
    "name": "aiAssetLibraryCategories",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AIAssetLibraryCategoryDTO",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sortOrder",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "modifiedDate",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "assetLibraryQueriesAIAssetLibraryCategoriesQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "assetLibraryQueriesAIAssetLibraryCategoriesQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "1ff74533f3bc4131c4d650f4bf7a227b",
    "id": null,
    "metadata": {},
    "name": "assetLibraryQueriesAIAssetLibraryCategoriesQuery",
    "operationKind": "query",
    "text": "query assetLibraryQueriesAIAssetLibraryCategoriesQuery(\n  $searchName: String\n  $sortBy: AIAssetLibrarySortBy\n  $sortDirection: SortDirection\n) {\n  aiAssetLibraryCategories(searchName: $searchName, sortBy: $sortBy, sortDirection: $sortDirection, first: 50) {\n    nodes {\n      id\n      name\n      sortOrder\n      createdDate\n      modifiedDate\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3d0f51a9d9f5753ab10eec8bc8369b7b";

export default node;
